<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2IEuwO/images/backcover.jpg?1707220969312" alt="This image is the cover for the book Grateful Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grateful Heart
      </h1>
      <p class="bookDescription body article font2">
        <b>Mealtime is a moment to give thanks—a collection of 365 blessings that “traverses all spiritual traditions.”—<i>Library Journal</i></b><br/>  <br/> Today there is a deep hunger for connection with ourselves, with nature, and with others, says life coach and <i>New York Times</i>-bestselling author of <i>Attitudes of Gratitude</i> M. J. Ryan. What <i>A Grateful Heart</i> offers, from a wide variety of spiritual disciplines and secular perspectives, is a way of satisfying that hunger by setting aside time before we eat to acknowledge the blessings in our lives. When we give thanks, we take our place in the great wheel of life, recognizing our connection to one another and to all of creation.<br/><br/> Reclaim and enrich the tradition of pausing before the evening meal to give thanks. Drawing from a range of religious and cultural practices, the 365 blessings in this book celebrate friendship, love, peace, reconciliation, the body, nature, joy, and appreciation of the moment. This illustrated feast for the mind includes quotations from Martin Luther King Jr., Thich Nhat Hanh, Gandhi, Rumi, Mother Teresa, Helen Keller, Denise Levertov, the Bible, and the Tao Te Ching, among many others.<br/><br/> M.J. Ryan wrote <i>A Grateful Heart</i> to encourage families to share the experience of being part of something greater than themselves. With that in mind, the book includes 365 traditional and nontraditional blessings organized into four sections corresponding to the seasons.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. J. Ryan
      </h2>
      
      <p class="authorDescription body article"><P>Known internationally as an expert on change, inspirational speaker and human development guru&#160;<B>M.J. Ryan</B>&#160;works as an executive coach to senior executives and entrepreneurs around the world to accelerate business success and personal fulfillment. She combines a practical approach gained from being the CEO of Conari Press with methodologies from neuroscience, positive psychology, and asset-focused learning to help clients and readers more easily meet their goals.</P><P>A highly successful author, Ryan is known for co-creating the&#160;<I>Random Acts of Kindness</I>&#160;series, as well as writing best-sellers such as&#160;<I>A Grateful Heart</I>,&#160;<I>Atitudes of Gratitude</I>,&#160;<I>The Power of Patience</I>, and her AdaptAbility book&#160;<I>How to Survive Change . . . You Didn't Ask For</I>. She lives in the San Francisco Bay area with her family.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Conari Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?066047df